import type {PriceVisibility, Profile} from '@profile-card/components/profile-card/types';
import type {PriceResponse, ProfileResponse} from '@api';

export function toPriceProfileCardData(price: PriceResponse): PriceVisibility | void {
    if (price.visibility === 'ON_DEMAND') {
        return {
            visibility: price.visibility,
        };
    }
    if (price.visibility === 'VISIBLE' && price.value) {
        return {
            visibility: price.visibility,
            formattedValue: price.value.formatted,
        };
    }
}

export function toProfileCardData(profile: ProfileResponse, targetCity?: string): Profile {
    return {
        ...profile,
        photoUrl: profile.photo.absoluteUrl,
        price: toPriceProfileCardData(profile.price) ?? undefined,
        skills: profile.skills.map((skill) => skill.label),
        targetCity,
        portfolio: profile.portfolio.map((portfolioItem) => ({
            title: portfolioItem.title,
            url: portfolioItem.picture.highResolutionUrl,
        })),
    };
}
